module.exports = __webpack_public_path__ + "static/img/u10.9984c5e0.png";